"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelNeoDark = exports.labelNeoLight = exports.labelNovoDark = exports.labelNovo = exports.label = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const label = {
    fontColor: color_const_1.default.pickledBluewood800,
    fontColorAction: color_const_1.default.dodgerBlue,
    fontColorActionDisabled: color_const_1.default.dodgerBlue300,
    fontColorActionHover: color_const_1.default.dodgerBlue300,
    fontColorStarRequired: color_const_1.default.coral,
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    fontStretch: 'normal',
    fontWeight: font_const_1.default.weightDefault,
    height: size_const_1.default.medium,
    lineHeight: font_const_1.default.lineHeightSm,
    letterSpacing: 'normal',
    borderSizeFocus: size_const_1.default.smallest,
    borderColorFocus: color_const_1.default.dodgerBlue,
    iconSet: 'classic',
    iconSize: 18,
    iconColor: color_const_1.default.steel700,
    actionLinkPaddingHorizontal: size_const_1.default.smallest,
    actionLinkPaddingVertical: size_const_1.default.small,
};
exports.label = label;
const labelNovo = {
    ...light.body01,
    fontColor: light.textColor01,
    fontColorAction: light.action05,
    fontColorActionDisabled: light.disabled02,
    fontColorActionHover: light.hover07,
    fontColorStarRequired: light.error01,
    fontStretch: 'normal',
    height: light.body01.lineHeight,
    iconSet: 'novo',
    iconSize: 16,
    iconColor: light.icon01,
    borderSizeFocus: light.spacing01,
    borderColorFocus: light.focus01,
    actionLinkPaddingHorizontal: light.spacing01,
    actionLinkPaddingVertical: light.spacing02,
};
exports.labelNovo = labelNovo;
const labelNovoDark = {
    ...labelNovo,
    fontColor: dark.textColor01,
    fontColorAction: dark.action05,
    fontColorActionDisabled: dark.disabled02,
    fontColorActionHover: dark.hover07,
    fontColorStarRequired: dark.error01,
    borderColorFocus: dark.focus01,
    iconColor: dark.icon01,
};
exports.labelNovoDark = labelNovoDark;
const labelNeoLight = {
    ...labelNovo,
    fontColor: neoLight.textColor01,
    fontColorAction: neoLight.action05,
    fontColorActionDisabled: neoLight.disabled02,
    fontColorActionHover: neoLight.hover07,
    fontColorStarRequired: neoLight.error01,
    height: neoLight.body01.lineHeight,
    iconColor: neoLight.icon01,
    borderColorFocus: neoLight.focus01,
};
exports.labelNeoLight = labelNeoLight;
const labelNeoDark = {
    ...labelNovoDark,
    fontColor: neoDark.textColor01,
    fontColorAction: neoDark.action05,
    fontColorActionDisabled: neoDark.disabled02,
    fontColorActionHover: neoDark.hover07,
    fontColorStarRequired: neoDark.error01,
    borderColorFocus: neoDark.focus01,
    iconColor: neoDark.icon01,
};
exports.labelNeoDark = labelNeoDark;
